<template>
    <v-app :style="{ background: $vuetify.theme.themes.light.background }">
        <v-main>
            <v-container class="mb-16 pt-10 pt-md-15">
                <div class="d-md-flex justify-md-space-between">
                    <div class="text-h4">
                      {{this.isCharibon ? "お申込み" : "買取お申込み"}}
                    </div>
                    <entry-steps current-step="STEP4"/>
                </div>

                <v-row class="pa-12" justify="center">
                    <v-img
                        :src="`${cdnUrl}/assets/images/regist/welcome_illust.svg`"
                        max-width="140"
                        alt="welcomeイラスト"
                    />
                </v-row>

                <v-row class="text-h5" justify="center" v-if="$vuetify.breakpoint.mdAndUp">
                  {{this.isCharibon ? "お申込み" : "買取申込み"}}が完了いたしました。
                </v-row>

                <member-grant-point-message v-if="getMemberFormLabels.isMemberRegisterGrantPoint !== null" :isMemberGrantPoint="getMemberFormLabels.isMemberRegisterGrantPoint" />

                <slot name="contents"></slot>

                <template v-if="isVaboo">
                  <!-- Rentracks CV Tag -->
                  <img :src="`https://www.rentracks.jp/secure/e.gifx?sid=456&pid=797&price=1&quantity=1&reward=-1&cinfo=${affiliateTrackingID}`" width="1" height="1" />

                  <span id="form-thanks-AID" style="display:none">{{ affiliateTrackingID }}</span>
                </template>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import {mapGetters} from "vuex";
import GtmOnVue from "../../../libs/gtmOnVue.js";
import EntrySteps from "../../molecules/buy/entry-steps.vue";
import MemberGrantPointMessage from "../../molecules/point/member-grant-point-message.vue";

export default {
    name: "quick-entry-complete",
    components: {
      MemberGrantPointMessage,
      EntrySteps,
    },
    data() {
        return {
            'identities': [
                '運転免許証',
                'パスポート',
                '写真付住民基本台帳カード',
                '国民年金手帳',
                '身体障害者手帳',
                '外国人登録証明書',
                '各種健康保険証',
            ],
            cdnUrl: VueConfig.cdn_url
        };
    },
    computed: {
      ...mapGetters({
        getMemberFormItems: 'member/getFormItems',
        getMemberFormLabels: 'member/getFormLabels',
        getBuyFormItems: 'buy/getFormItems',
        getBuyStateFormItems: 'buyState/getFormItems',
      }),
      isValueBooks() {
        return this.$siteCode === VueConfig.siteCode.valuebooks;
      },
      isVaboo(){
        return this.$siteCode === VueConfig.siteCode.vaboo
      },
      isCharibon() {
        return this.$siteCode === VueConfig.siteCode.charibon;
      },
     affiliateTrackingID(){
        return this.getBuyStateFormItems.buyNumber
      }
    },
    mounted() {
      if(this.isValueBooks) {
        GtmOnVue.sendGAEvent(
          'conversion_buy',
          '/sell/offer-with-registration/completed',
          this.getBuyStateFormItems.buyNumber,
          this.getBuyFormItems.campaignCode,

          this.getBuyFormItems.autoAppliedCouponCode,
          this.getBuyFormItems.selectedCampaignCode,
          this.getBuyFormItems.buybackCode,
          this.getMemberFormItems.emailSubscriptionCode,
          this.getBuyFormItems.numberOfPackages,
          this.getBuyFormItems.pickupDate,
          this.getBuyFormItems.pickupTimeCode,
          this.getBuyFormItems.sokufuriApplicationCode,
          // 買取LPの経路で紹介者の情報がセットされることはない為、nullをセット
          null,
          null,
        );
      }
      if(this.isVaboo) {
        GtmOnVue.sendGAEventVabooOfferCompleted(
          this.getBuyStateFormItems.buyNumber,
          this.getBuyFormItems.campaignCode,
          this.getMemberFormItems.emailSubscriptionCode,
          this.getBuyFormItems.numberOfPackages,
          this.getBuyFormItems.pickupDate,
          this.getBuyFormItems.pickupTimeCode,
          this.getBuyFormItems.sokufuriApplicationCode,
          this.getMemberFormItems.isAgreedCreateMainSiteAccount
        );
      } else if(this.isCharibon) {
        GtmOnVue.sendGAEventCharibonOfferCompleted(
          this.getBuyStateFormItems.buyNumber,
          this.getBuyFormItems.campaignCode,
          this.getMemberFormItems.emailSubscriptionCode,
          this.getBuyFormItems.numberOfPackages,
          this.getBuyFormItems.pickupDate,
          this.getBuyFormItems.pickupTimeCode,
          this.getBuyFormItems.sokufuriApplicationCode,
          this.getBuyFormItems.supportGroupId,
          this.getBuyFormItems.vbOfficeCode
        );
      }
    }
}
</script>

<style scoped lang="scss">
::v-deep .v-application--wrap {
    min-height: unset;
}
</style>